import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';

import { getUploadedPhotoById } from '../../../../../util/photo-upload';
import { photoUploadRemoveAction } from '../../../../../actions/photo-upload';

const withPhotoUploadCache = PhotoComponent => {
  class PhotoCacheProvider extends Component {
    static propTypes = {
      id: PropTypes.string,
      photoId: PropTypes.string,
      cachedPhoto: PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string,
      }),
      // @deprecated - Just use `thumbnails`
      thumbs: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
        }),
      ),
      thumbnails: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
        }),
      ),
      photoUploadRemove: PropTypes.func.isRequired,
    };

    componentDidMount() {
      const { id, photoId, thumbs, thumbnails, photoUploadRemove } = this.props;

      if (get(thumbs, 'length') || get(thumbnails, 'length')) {
        photoUploadRemove(photoId || id);
      }
    }

    getThumbnails = () => {
      const { thumbs, thumbnails, cachedPhoto } = this.props;

      if (get(thumbs, 'length') || get(thumbnails, 'length')) {
        return thumbs || thumbnails;
      }

      return cachedPhoto && [{ url: cachedPhoto.url, width: 999, height: 999 }];
    };

    render() {
      const { cachedPhoto, photoUploadRemove, ...props } = this.props;

      return (
        <PhotoComponent
          {...props}
          thumbs={this.getThumbnails()}
          thumbnails={this.getThumbnails()}
        />
      );
    }
  }

  const mapStateToProps = ({ photoUploads }, ownProps) => ({
    cachedPhoto: getUploadedPhotoById(
      photoUploads.photos,
      ownProps.photoId || ownProps.id,
    ),
  });

  const mapDispatchToProps = {
    photoUploadRemove: photoUploadRemoveAction,
  };

  return connect(mapStateToProps, mapDispatchToProps)(PhotoCacheProvider);
};

export default withPhotoUploadCache;
